import http from "./constants/http";
import resources from "./constants/resources";

export const adLinksAPI = async (body) => {
  const res = await http(resources.ADLINKS).post(body);

  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};
